import React from 'react'

const Logo = ({ height = 25.275, width = 115 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 115 25.275"
    >
      <path
        fill="#29313e"
        d="M22,38V55.692H35.9V52.23h-9.93V48.514H34.6V45.053H25.971v-3.59h9.8V38Z"
        transform="translate(-22 -30.418)"
      />
      <path
        fill="#29313e"
        d="M36,38H49.77v3.462h-9.8v3.589h8.622v3.462H39.972v3.716H49.9v3.463H36Z"
        transform="translate(-18.308 -30.418)"
      />
      <path
        fill="#29313e"
        d="M50,41.254h3.993v1.952a8.327,8.327,0,0,1,.749-.834,5.231,5.231,0,0,1,.906-.705,4.537,4.537,0,0,1,1.116-.487A4.927,4.927,0,0,1,58.141,41a4.861,4.861,0,0,1,2.4.564,3.863,3.863,0,0,1,1.563,1.616,6.369,6.369,0,0,1,2.048-1.628A5.788,5.788,0,0,1,66.73,41a4.7,4.7,0,0,1,3.493,1.273,5.108,5.108,0,0,1,1.26,3.743V54.9H67.491V47.307a3.085,3.085,0,0,0-.6-2.069,2.165,2.165,0,0,0-1.733-.7,2.287,2.287,0,0,0-1.773.7,2.953,2.953,0,0,0-.644,2.069V54.9H58.746V47.307a3.079,3.079,0,0,0-.6-2.069,2.165,2.165,0,0,0-1.733-.7,2.289,2.289,0,0,0-1.773.7,2.953,2.953,0,0,0-.643,2.069V54.9H50Z"
        transform="translate(-14.615 -29.626)"
      />
      <path
        fill="#29313e"
        d="M76.976,51.426a3.666,3.666,0,0,0,1.452-.27,3.183,3.183,0,0,0,1.762-1.831A3.713,3.713,0,0,0,80.426,48v-.047a3.547,3.547,0,0,0-.249-1.327,3.347,3.347,0,0,0-.719-1.1,3.521,3.521,0,0,0-1.118-.763,3.486,3.486,0,0,0-1.415-.282,3.687,3.687,0,0,0-1.452.27,3.177,3.177,0,0,0-1.761,1.831,3.688,3.688,0,0,0-.237,1.327v.047a3.544,3.544,0,0,0,.249,1.327,3.327,3.327,0,0,0,.72,1.1,3.545,3.545,0,0,0,1.1.763,3.474,3.474,0,0,0,1.427.281M76.926,54.9a7.026,7.026,0,0,1-2.756-.535A6.7,6.7,0,0,1,71.978,52.9,6.928,6.928,0,0,1,70,48v-.05A6.89,6.89,0,0,1,76.975,41a7.007,7.007,0,0,1,2.756.536,6.7,6.7,0,0,1,2.193,1.469A6.911,6.911,0,0,1,83.9,47.9v.05A6.889,6.889,0,0,1,76.926,54.9"
        transform="translate(-9.341 -29.626)"
      />
      <path
        fill="#29313e"
        d="M107.11,46.319a3.023,3.023,0,0,0-.993-1.83,3.112,3.112,0,0,0-2.124-.7,3.037,3.037,0,0,0-3.2,2.527ZM104.4,55.165a7.873,7.873,0,0,1-2.946-.544A6.8,6.8,0,0,1,99.1,53.072a7.184,7.184,0,0,1-1.545-2.378A8.072,8.072,0,0,1,97,47.637v-.054a8.341,8.341,0,0,1,.516-2.935,7.489,7.489,0,0,1,1.44-2.419,6.756,6.756,0,0,1,2.207-1.63A6.633,6.633,0,0,1,104,40a6.733,6.733,0,0,1,3.066.652,6.275,6.275,0,0,1,2.155,1.753,7.409,7.409,0,0,1,1.268,2.527,10.745,10.745,0,0,1,.409,2.976c0,.163-.005.335-.013.517s-.023.372-.039.571h-9.858a3.5,3.5,0,0,0,1.2,2.133,3.538,3.538,0,0,0,2.26.721,4.368,4.368,0,0,0,1.8-.354,6.124,6.124,0,0,0,1.639-1.141l2.3,2.093a7.165,7.165,0,0,1-2.43,2A7.368,7.368,0,0,1,104.4,55.165Z"
        transform="translate(-2.22 -29.89)"
      />
      <path
        fill="#29313e"
        d="M110,37h3.791V55.956H110Z"
        transform="translate(1.209 -30.681)"
      />
      <path
        fill="#29313e"
        d="M94.6,41l-3.755,5.9L87.09,41H82l8.846,13.9L99.692,41Z"
        transform="translate(-6.176 -29.626)"
      />
      <path
        fill="#b18935"
        d="M97.1,34.85a8.29,8.29,0,0,0-12.511,0A10.178,10.178,0,0,0,82,41.731c0,.128,0,.253.007.379h4.579q-.013-.188-.013-.379a4.294,4.294,0,1,1,8.548,0c0,.128-.005.254-.014.379h4.578c.006-.126.008-.251.008-.378A10.18,10.18,0,0,0,97.1,34.85"
        transform="translate(-6.176 -32)"
      />
    </svg>
  )
}

export default Logo
